export type MethodParameters = {
  /**
   * The hex encoded calldata to perform the given operation
   */
  calldata: string;
  /**
   * The amount of ether (wei) to send in hex.
   */
  value: string;
};
